<template>
  <div class="all">
    <div class="header-top">
      <div>
        <el-button v-if="addFrame" size="small" type="primary" @click="changeRemark(0, '')"> 新增 </el-button>
        <el-button v-if="deleFrame" :disabled="seletionList.length == 0" size="small" type="danger" plain @click="deleteBatchBtn"> 批量删除 </el-button>
      </div>
      <div>
        <el-form ref="form" inline size="small" class="formStyle">
          <el-form-item>
            <el-input v-model="colCnName" size="mini" placeholder="请输入字段名称搜索" style="width: 200px" clearable @input="getList(1)">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="类型:">
            <el-select v-model="typeId" size="mini" placeholder="请选择" clearable filterable @change="getList(1)">
              <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否显示:">
            <el-select v-model="isShow" size="mini" placeholder="请选择" clearable filterable @change="getList(1)">
              <el-option v-for="item in isShowList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="midd">
      <el-table ref="multipleTable" :key="timeStamp" :data="tableData" border highlight-current-row height="100%" @selection-change="selectListHandler">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column :selectable="checkboxInit" type="selection" width="55px" align="center" @selection-change="selectListHandler"> </el-table-column>
        <el-table-column width="60px" align="center">
          <i class="iconfont icon-drag drag-option my-handle" style="cursor: pointer"></i>
        </el-table-column>
        <el-table-column label="序号" type="index" align="center" width="60px" />
        <el-table-column label="字段名称" prop="colCnName" min-width="200px">
          <template #default="{ row }">
            <el-link v-if="editFrame" type="primary" @click="changeRemark(1, row)">
              <span class="tabLinkSpan" :title="row.colCnName">{{ row.colCnName }}</span>
            </el-link>
            <span v-else class="tabLinkSpan" :title="row.colCnName">{{ row.colCnName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="typeId">
          <template slot-scope="scope">
            <span v-if="scope.row.typeId == '1'">输入值</span>
            <span v-if="scope.row.typeId == '2'">选择人员</span>
            <span v-if="scope.row.typeId == '3'">选择图章</span>
          </template>
        </el-table-column>
        <el-table-column label="是否显示" prop="isShow">
          <template slot-scope="scope">
            <span v-if="scope.row.isShow == 1">显示</span>
            <span v-if="scope.row.isShow == 0">不显示</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="dataOrder" />
        <el-table-column label="创建人" prop="createUserName" />
        <el-table-column label="添加时间" prop="createTime" min-width="120px" />
        <el-table-column v-if="deleFrame||editFrame" label="操作" min-width="120px">
          <template slot-scope="scope">
            <span v-if="editFrame" class="btn" title="编辑" @click="changeRemark(1, scope.row)">
              <i class="el-icon-edit-outline"></i>
            </span>
            <span v-if="deleFrame" class="btn" title="删除" @click="deleteBtn(scope.row)">
              <i class="el-icon-delete"></i>
            </span>
            <span v-if="editFrame" class="btn" title="上移" @click="moveBtn(scope.row, 1)"><i class="el-icon-top"></i></span>
            <span v-if="editFrame" class="btn" title="下移" @click="moveBtn(scope.row, 2)"><i class="el-icon-bottom"></i></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page :page="page" class="page-2" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData"></page>
    <!--修改 -->
    <el-dialog
      v-dialogDrag
      :title="frameTilte"
      :visible.sync="editPersonDialog"
      :before-close="getReset"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <el-form ref="frameForm" :model="frameForm" :rules="rules" label-width="82px" size="small">
        <el-form-item label="字段名称:" prop="colCnName">
          <el-input ref="colCnName" v-model="frameForm.colCnName" maxlength="20" show-word-limit clearable size="small" />
        </el-form-item>
        <el-form-item label="类型:" prop="typeId">
          <el-radio-group v-model="frameForm.typeId">
            <el-radio label="1">输入值</el-radio>
            <el-radio label="2">选择人员</el-radio>
            <el-radio label="3">选择图章</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示:" prop="isShow">
          <el-radio-group v-model="frameForm.isShow">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序:" prop="dataOrder">
          <el-input-number v-model="frameForm.dataOrder" :min="0" :max="255" style="width: 100%" size="small"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="getReset">取 消</el-button>
        <el-button v-if="submitType == 0" type="primary" size="small" @click="addChangeRemark">确 定</el-button>
        <el-button v-if="submitType == 1" type="primary" size="small" @click="sureChangeRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/CommonDP/service/frame-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import page from "@/CommonDP/components/paging";
import { mapState } from "vuex";
import Sortable from "sortablejs";
const newEmptyStandardForm = () => ({
  colCnName: "",
  typeId: "1",
  isShow: 1,
  dataOrder: ""
});
export default {
  name: "FrameField",
  components: { page },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: [],
      editPersonDialog: false,
      frameForm: newEmptyStandardForm(),
      submitType: "",
      id: "",
      rules: {
        colCnName: [{ required: true, message: "请输入字段名称", trigger: "change" }]
      },
      addFrame: checkPermission(this.$allPerms.FRAMEFIELD_ADD),
      editFrame: checkPermission(this.$allPerms.FRAMEFIELD_EDIT),
      deleFrame: checkPermission(this.$allPerms.FRAMEFIELD_DALE),
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      seletionList: [],
      colCnName: "",
      typeId: "",
      isShow: "",
      typeList: [
        {
          name: "输入值",
          id: "1"
        },
        {
          name: "选择人员",
          id: "2"
        },
        {
          name: "选择图章",
          id: "3"
        }
      ],
      isShowList: [
        {
          name: "显示",
          id: 1
        },
        {
          name: "不显示",
          id: 0
        }
      ],
      timeStamp: +new Date(),
      going: false,
      showMessage: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    frameTilte() {
      return ["新增", "修改"][this.submitType];
    }
  },
  mounted() {
    this.getList(1);
    this.rowDrop();
  },
  methods: {
    rowDrop() {
      // 此时找到的元素是要拖拽元素的父容器
      const dom = document.querySelector(".all .midd .el-table__body-wrapper tbody");
      this._sortable = Sortable.create(dom, {
        handle: ".all .midd .my-handle",
        onEnd: async (e) => {
          const { newIndex, oldIndex } = e;
          console.log(e, "2", newIndex, oldIndex);
          // 相等则不做任何操作
          if (newIndex === oldIndex) return;
          const info = { id: `${this.tableData[newIndex].id},${this.tableData[oldIndex].id}` };
          this.going = true;
          try {
            await this.moveBtn(info, 3, `${newIndex},${oldIndex}`);
            // 用这玩意，不使用key刷新eltable展示会有问题，刷新了，则dom节点整个被替换需要重新install Sortable
            this.timeStamp = +new Date();
            await this.$nextTick();
            this.rowDrop();
            this.going = false;
            this.showMessage = false;
          } catch (error) {
            this.going = false;
            this.showMessage = false;
            console.error(error);
          }
        },
        onMove: () => {
          if (this.going) {
            if (!this.showMessage) {
              this.$warn("后台接口尚未处理完毕，请稍后操作");
              this.showMessage = true;
            }
            return false;
          }
        }
      });
    },
    checkboxInit(row) {
      if (row.def === 0) {
        return 0;
      } // 不可勾选
      else {
        return 1;
      } // 可勾选
    },
    // 列表
    async getList(index = 1) {
      this.loading = true;
      const {
        page: { pageSize },
        enterpriseId,
        colCnName,
        typeId,
        isShow
      } = this;
      const params = { pageNum: index, pageSize, enterpriseId, colCnName, typeId, isShow };
      const { data, pageNum, totalCount } = await request.frameCustomizationList(params);
      this.tableData = data;
      this.page.pageNum = pageNum;
      this.page.totalCount = totalCount;
      this.loading = false;
    },
    // 批量选中
    selectListHandler(list) {
      this.seletionList = list;
    },
    async deleteBatchBtn() {
      const a = disablePrompt();
      if (a) {
        const list = this.seletionList.map(({ id: id }) => id);
        await this.$confirm(`您确定要删除当前${list.length}项`, "警告", {
          type: "warning"
        });
        const res = await request.deleteFrameCustomization(list);
        if (res.result === "0") {
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
        await this.getList(1);
      }
    },
    async deleteBtn(row) {
      const a = disablePrompt();
      if (a) {
        await this.$confirm(`您确定要删除当前${row.colCnName}字段吗`, "警告", {
          type: "warning"
        });
        const res = await request.deleteFrameCustomization([row.id]);
        if (res.result === "0") this.$message.success("删除成功");
        await this.getList(1);
      }
    },
    async moveBtn(row, moveFlag, dataOrder) {
      try {
        const params = {
          id: row.id,
          moveFlag,
          dataOrder,
          enterpriseId: this.enterpriseId
        };
        const res = await request.moveFrameCustomization(params);
        if (res.result === "0") this.$message.success(`移动成功`);
        await this.getList(this.page.pageNum);
      } catch (error) {
        console.log(error);
      }
    },

    fetchData(val) {
      this.getList(val);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList(1);
    },
    // 新增
    async changeRemark(val, row) {
      const a = disablePrompt();
      if (a) {
        this.id = row.id;
        this.editPersonDialog = true;
        this.submitType = val;
        if (val === 1) {
          this.getDetail(row.id);
        } else {
          this.$nextTick(() => {
            this.$refs.colCnName.focus();
            this.$refs.frameForm.resetFields();
          });
        }
      }
    },
    // 获取详情
    async getDetail(id) {
      const { data } = await request.queryFrameCustomizationDetail(id);
      this.frameForm = data;
    },
    async addChangeRemark() {
      await this.$refs.frameForm.validate();
      const {
        frameForm: { colCnName, typeId, isShow, dataOrder },
        enterpriseId
      } = this;
      const params = { colCnName, typeId, isShow, dataOrder, enterpriseId };
      const res = await request.addFrameCustomization(params);
      if (res.result === "0") this.$message.success("添加成功");
      await this.getReset();
      await this.getList(1);
    },
    // 修改保存
    async sureChangeRemark() {
      await this.$refs.frameForm.validate();
      const {
        frameForm: { colCnName, typeId, isShow, dataOrder },
        enterpriseId,
        id
      } = this;
      const params = { colCnName, typeId, isShow, dataOrder, enterpriseId, id };
      const res = await request.updateFrameCustomization(params);
      if (res.result === "0") this.$message.success("修改成功");
      await this.getReset();
      await this.getList(1);
    },
    // 清空表单
    getReset() {
      this.$refs.frameForm.resetFields();
      this.editPersonDialog = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
  padding: 0 var(--big-space);
  display: flex;
  flex-direction: column;
  .formStyle {
    /deep/ .el-input__suffix {
      top: -3px;
    }
  }
}
.header-top {
  padding: var(--middle-space) 0;
  display: flex;
  justify-content: space-between;
  .header_b {
    margin-top: 10px;
    margin-left: 20px;
  }
}
.midd {
  height: 1px;
  flex-grow: 1;

  .btn {
    cursor: pointer;
    color: #858ebd;
    margin-right: 5px;
    font-size: 15px;
  }
}
.page-2 {
  padding: var(--middle-space) 0;
  text-align: right;
}
</style>
